import { ModuleIntegration } from 'data/terra/ModuleIntegration';
import * as types from './actionTypes';

export interface ModuleState {
  integrations: ModuleIntegration[];
  integrationsOfSelectedEnv: ModuleIntegration[];
}

const initialState: ModuleState = {
  integrations: [],
  integrationsOfSelectedEnv: [],
};

export default function reduce(
  state: ModuleState = initialState,
  action: types.ModuleAction
): ModuleState {
  switch (action.type) {
    case types.FETCH_MODULE_INTEGRATIONS_RESULT: {
      return {
        ...state,
        integrations: action.integrations,
        integrationsOfSelectedEnv: action.integrationsOfSelectedEnv,
      };
    }
    default:
      return state;
  }
}
